/*
 * src/components/BankAccounts/AddAccountTooltip.jsx
 * Description: PAYAPP-1085
 * Copyright (c) 2021 PredictiveUX
 */
import React from "react";

import questionIcon from "../../styles/assets/icon_question.svg";
import pncLogo from "../../styles/assets/icon_pnc.png";
import "./addAccountTooltip.css";

const AddAccountTooltip = ({ dismissHandler, isVisible, plaidButton }) => {
  const closePNCNotification = () => {
    const el = document.getElementById("pncFlyover");
    if (el) {
      el.style.left = "245px";
      el.style.opacity = "0";
      el.style.pointerEvents = "none";
    }
  };

  const openPNCNotification = () => {
    const el = document.getElementById("pncFlyover");
    if (el) {
      el.style.left = "0px";
      el.style.opacity = "1";
      el.style.pointerEvents = "all";
    }
  };
  return (
    <div
      id="add-account-container"
      className="add-account-container"
      hidden={!isVisible}
    >
      <div id="pncFlyover">
        <div className="notification">
          <div className="content">
            <div className="closeIcon" role="button" tabIndex="0">
              <i className="fa fa-times" onClick={closePNCNotification} />
            </div>
            <div className="notice">Bank Notice</div>
            <div className="disclaimer">
              The bank you selected is not supported by our 3rd party 
              service provider used to connect to your bank.<br/>
              Please try another bank that is supported on the platform 
              or contact your title agency or real estate brokerage 
              for alternative methods of payment.
            </div>
          </div>
        </div>
      </div>
      <div id="add-account-arrow"></div>
      <div id="add-account-tooltip">
        <div
          id="add-account-close-icon"
          role="button"
          tabIndex="0"
          onClick={() => dismissHandler(false)}
          onKeyUp={() => dismissHandler(false)}
        >
          <i className="fa fa-times" />
        </div>
        <div id="add-account-content">
          <div className="title">
            Connect to over 16,000 banks
          </div>
          <div className="findMyBank" onClick={() => dismissHandler(false)}>
            {plaidButton}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAccountTooltip;
